module.exports = __webpack_public_path__ + "img/nature-001.dfcddad2.jpg";